module.exports = {
  "country": "IT",
  "artist": "Gigliola Qinquetti",
  "song": "Non ho l'eta",
  "year": "1964",
  "place": "1",
  "spotify": "07rZol7bEXJSUHIcwah0eq"
};